"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { LazyMotion, domAnimation, m } from "framer-motion";
import { densifyLogoStrip, LOGO_SLOT, type LogoStripLogo } from "@/lib/logo-strip";
type Props = {
  heading: string;
  description?: string | null;
  logos: LogoStripLogo[];
};

/** Jak About / inne sekcje główne. */
const slideUp = {
  hidden: {
    y: 20,
    opacity: 0
  },
  visible: (i: number) => ({
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.8,
      ease: [0.215, 0.61, 0.355, 1],
      delay: i * 0.1
    }
  })
} as const;
export default function Logo3Client(t0) {
  const $ = _c(22);
  const {
    heading,
    description,
    logos
  } = t0;
  let set;
  let t1;
  if ($[0] !== logos) {
    set = densifyLogoStrip(logos);
    t1 = [...set, ...set];
    $[0] = logos;
    $[1] = set;
    $[2] = t1;
  } else {
    set = $[1];
    t1 = $[2];
  }
  const track = t1;
  let t2;
  if ($[3] !== description) {
    t2 = description?.trim() || "";
    $[3] = description;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const descriptionText = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      once: true,
      amount: 0.15
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== heading) {
    t4 = <m.h2 variants={slideUp} custom={0} className="text-[20px] font-semibold uppercase tracking-wide">{heading}</m.h2>;
    $[6] = heading;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== descriptionText) {
    t5 = descriptionText ? <m.p variants={slideUp} custom={1} className="mx-auto mt-2 max-w-md text-[14px] leading-relaxed text-secondary/70 md:max-w-lg">{descriptionText}</m.p> : null;
    $[8] = descriptionText;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <header className="mx-auto mb-12 text-center md:mb-14 lg:mb-16">{t4}{t5}</header>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== set || $[14] !== track) {
    t7 = <m.div variants={slideUp} custom={2} className="relative overflow-hidden [contain:layout] [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)] [-webkit-mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]"><ul className="m-0 flex w-max list-none items-center gap-x-10 p-0 motion-safe:animate-loop-horizontally-half motion-reduce:animate-none motion-safe:hover:[animation-play-state:paused] motion-safe:will-change-transform md:gap-x-12">{track.map((logo, index) => {
          const decorative = index >= set.length;
          const eager = !decorative && index < 3;
          return <li key={`${logo._key}-${index}`} className="relative flex h-12 w-32 shrink-0 items-center justify-center md:h-14 md:w-36"><Image src={logo.src} alt={decorative ? "" : logo.alt} fill={true} sizes={`${LOGO_SLOT.width}px`} className="object-contain object-center opacity-70 grayscale transition-[opacity,filter] duration-300 hover:opacity-100 hover:grayscale-0" unoptimized={logo.isSvg} {...!logo.isSvg ? {
              quality: 70
            } : {}} loading={eager ? "eager" : "lazy"} fetchPriority="low" decoding="async" draggable={false} aria-hidden={decorative || undefined} /></li>;
        })}</ul></m.div>;
    $[13] = set;
    $[14] = track;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="container mx-auto px-[5%]"><div className="mx-auto max-w-7xl">{t6}{t7}</div></div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== heading || $[20] !== t8) {
    t9 = <LazyMotion features={domAnimation}><m.section id="logo-strip" aria-label={heading} initial="hidden" whileInView="visible" viewport={t3} className="bg-primary pb-16 pt-8 text-secondary md:pb-20 md:pt-10 lg:pb-24 lg:pt-12">{t8}</m.section></LazyMotion>;
    $[19] = heading;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}